import { initializeApp, getApp, getApps } from 'firebase/app';
import { getMessaging, isSupported, Messaging } from "firebase/messaging";

// Replace these values with your own Firebase configuration from the Firebase Console
const firebaseConfig = {
apiKey: "AIzaSyBPTgOPq8JiMIjnyLni0KDZHexvLAvgWj0",
  authDomain: "testliri-e6ab6.firebaseapp.com",
  projectId: "testliri-e6ab6",
  storageBucket: "testliri-e6ab6.firebasestorage.app",
  messagingSenderId: "958887188675",
  appId: "1:958887188675:web:6cae7b767c1f822522ea76",
  measurementId: "G-Z8VK4261FN"

};

// Initialize Firebase
// Note: The standup module (src/standup/firebase.ts) already initializes the
// default Firebase app for a different project. This messaging app points at a
// separate project, so it MUST use its own named instance — otherwise both
// register as '[DEFAULT]' and Firebase throws app/duplicate-app.
// We also reuse the existing named app (getApp) when present so Hot Module
// Replacement re-runs don't attempt a second initializeApp and re-throw.
const MESSAGING_APP_NAME = "messaging";
const app = getApps().some((a) => a.name === MESSAGING_APP_NAME)
  ? getApp(MESSAGING_APP_NAME)
  : initializeApp(firebaseConfig, MESSAGING_APP_NAME);

// Initialize Firestore with Offline Persistence enabled
// Note: We avoid persistentMultipleTabManager in native environments (Tauri/Capacitor)
// to prevent deadlocks between multiple webview processes (Main vs Tray).
// export const db = initializeFirestore(app, {
//     localCache: persistentLocalCache({})
// });




let messaging: Messaging | null = null;

export const getFirebaseMessaging = async (): Promise<Messaging | null> => {
  try {
    const supported = await isSupported();

    if (!supported) {
      console.warn("Firebase Messaging is not supported in this browser.");
      return null;
    }

    if (!messaging) {
      messaging = getMessaging(app);
    }

    return messaging;
  } catch (error) {
    console.error("Failed to initialize Firebase Messaging:", error);
    return null;
  }
}

